module.exports = __webpack_public_path__ + "static/media/guide_Page_28.70e82112.png";